<div
  [reactComponent]="DiscoverTilesComponent$"
  [props]="{ tiles, options: discoverTilesOptions, businessVertical: 'groceries', onTileToggle: onTileToggleCallBack }"
></div>
<button class="mat-icon-css-loader-button" mat-icon-button aria-label="-"></button>
